import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter as Router, matchRoutes } from "react-router-dom";
import { Authenticator } from "@aws-amplify/ui-react";
import classNames from "classnames";
import { selectShouldShowNav } from "./pages/AuthScreens";
import { actions } from "./pages/AuthScreens/authScreens.reducers";
import { Navbar, SidePanel } from "./components/organisms";
import { selectIsAuthenticated } from "./pages/UserProfile";
import AccessProvider from "./infrastructure/Authentication/AccessProvider";
import RoutesLayout from "./infrastructure/RoutesLayout";
import { BOOLEAN, ROUTES } from "./constants";

const STRING = "string";
const { TRUE } = BOOLEAN;
const { LOGIN, SELECT_WORKSPACE } = ROUTES;

const queryClient = new QueryClient();
const { setShouldShowNav } = actions;

const App = () => {
  const dispatch = useDispatch();
  const [shouldShowNavAndSidePanel, setShouldShowNavAndSidePanel] =
    useState(false);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const shouldShowNav = useSelector(selectShouldShowNav);

  useEffect(() => {
    const isValid =
      typeof isAuthenticated === STRING
        ? isAuthenticated === TRUE
        : isAuthenticated;

    const hideNav = matchRoutes([{ path: SELECT_WORKSPACE }, { path: LOGIN }], {
      pathname: window.location.pathname,
    });

    if (hideNav) dispatch(setShouldShowNav(false));
    else dispatch(setShouldShowNav(isValid));
  }, [dispatch, isAuthenticated]);

  useEffect(() => {
    setShouldShowNavAndSidePanel(shouldShowNav);
  }, [shouldShowNav]);

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Authenticator.Provider>
          <AccessProvider>
            <Router>
              <>
                {shouldShowNavAndSidePanel && <Navbar />}
                <main
                  className={classNames({ flex: shouldShowNavAndSidePanel })}
                >
                  {shouldShowNavAndSidePanel && <SidePanel />}
                  <RoutesLayout
                    shouldShowNavAndSidePanel={shouldShowNavAndSidePanel}
                  />
                </main>
              </>
            </Router>
          </AccessProvider>
        </Authenticator.Provider>
      </QueryClientProvider>
    </>
  );
};

export default App;
